/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'
import FontNumber from '../common/FontNumber'
import FlexBox from '../common/FlexBox'
import { Button } from '../common/Button'

const Wrapper = styled.div`
  background: rgba(33, 40, 51, 0.6);
  margin-bottom: 10px;
  border-radius: 3px;
  color: ${({ status }) => (status === 'Canceled' ? '#48515D' : '#fff')};
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #0b0e11;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: ${({ status }) => (status === 'Canceled' ? '#48515D' : '#848E9C')};
  .symbol {
    font-size: 14px;
    margin-right: 5px;
  }
`

const Body = styled.div`
  padding: 10px 15px;
  font-size: 13px;
  position: relative;
  .hash {
    font-size: 14px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 10px;
  }
`

export const Filled = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 2px solid;
  border-color: #48515d;
  line-height: 30px;
  text-align: center;
  margin-right: 15px;
  position: relative;
  color: ${({ type, status, theme }) =>
    status === 'Canceled' ? '#48515D' : type === 'Buy' ? theme.up : theme.down};
  .value {
    font-size: 20px;
    transform: scale(0.5) translateX(-50%);
    width: 200%;
    text-align: center;
  }
  svg {
    stroke: ${({ type, theme }) => (type === 'Buy' ? theme.up : theme.down)};
    position: absolute;
    top: -2px;
    left: -2px;
    transition: all 0.3s ease;
    stroke-width: 2;
    stroke-dasharray: 300;
    stroke-dashoffset: 300;
    fill: none;
    width: 35px;
    height: 35px;
  }
`

export const Side = styled.div`
  width: 28px;
  height: 14px;
  line-height: 15px;
  text-align: center;
  background: ${({ type, theme }) => (type === 'Buy' ? theme.upLight : theme.downLight)};
  color: ${({ type, theme }) => (type === 'Buy' ? theme.up : theme.down)};
  border-radius: 1px;
`

const PriceAndAmount = styled.div`
  color: ${({ status }) => (status === 'Canceled' ? '#48515D' : '#848E9C')};
  .title {
    width: 46px;
    text-align: left;
    margin-right: 20px;
  }
  .value {
    .total {
      font-size: 12px;
    }
  }
`

const CancelButton = styled(Button)`
  width: auto;
  background: rgba(33, 40, 51, 0.6);
  padding: 0 10px;
  height: 24px;
  line-height: 23px;
  border: 1px solid ${({ theme }) => theme.highlight};
  box-sizing: border-box;
  font-size: 13px;
  margin-right: 10px;
  border-color: ${({ theme }) => theme.highlight};
  color: ${({ theme }) => theme.highlight};
  position: absolute;
  right: 15px;
  bottom: 15px;
  @media (max-width: 768px) {
    width: 60px;
  }
`

const StatusButton = styled(CancelButton)`
  border-color: ${({ status, theme }) => (status === 'Filled' ? theme.up : theme.highlight)};
  color: ${({ status, theme }) => (status === 'Filled' ? theme.up : theme.highlight)};
`

const CanceledStatusButton = styled(CancelButton)`
  border-color: #48515d;
  color: #48515d;
`

class OrderItem extends PureComponent {
  static propTypes = {
    order: PropTypes.object,
    cancel: PropTypes.func,
  }

  static defaultProps = {
    order: {},
    cancel: null,
  }

  _cancel = ev => {
    const { order, cancel } = this.props
    cancel && cancel(order, ev)
  }

  _getDisplayFilled = () => {
    const {
      order: { filled },
    } = this.props
    if (filled > 0 && filled < 100) {
      return filled.toFixed(2)
    }

    return filled
  }

  render() {
    const {
      order: { pair, side, date, txHash, filled, amount, price, orderId, status, cumulateQuantity },
      cancel,
    } = this.props
    const displayFilled = this._getDisplayFilled()
    return (
      <Wrapper key={orderId} status={status}>
        <Header status={status}>
          <FlexBox align="center">
            <div className="symbol">{pair}</div>
            <Side type={side}>{side}</Side>
          </FlexBox>
          <div className="date">
            <FontNumber value={moment(date).format('YYYY-MM-DD hh:mm:ss')} />
          </div>
        </Header>
        <Body>
          <div className="hash">
            <FontNumber value={txHash} />
          </div>
          <FlexBox>
            <Filled type={side} status={status}>
              <div className="value">{`${displayFilled}%`}</div>
              <svg style={{ strokeDashoffset: 300 - filled }}>
                <circle r="16" cx="17" cy="17" />
              </svg>
            </Filled>
            <PriceAndAmount status={status}>
              <FlexBox>
                <div className="title">Amount</div>
                <div className="value">
                  <FontNumber value={cumulateQuantity} />
                  &nbsp;/&nbsp;
                  <span className="total">
                    <FontNumber value={amount} />
                  </span>
                </div>
              </FlexBox>
              <FlexBox>
                <div className="title">Price</div>
                <div className="value">
                  <FontNumber value={price} />
                </div>
              </FlexBox>
            </PriceAndAmount>
            {cancel ? (
              <CancelButton onClick={this._cancel}>Cancel</CancelButton>
            ) : status === 'Canceled' ? (
              <CanceledStatusButton>{status}</CanceledStatusButton>
            ) : (
              <StatusButton status={status}>{status}</StatusButton>
            )}
          </FlexBox>
        </Body>
      </Wrapper>
    )
  }
}

export default OrderItem
